module.exports = __webpack_public_path__ + "img/mercedes.fc65743b.png";